import { Component, Input, OnInit } from '@angular/core';
import { ColumnSortService } from 'src/app/components/dynamic-data-list/services/column-sort.service';
import { ProtoList } from 'src/app/components/pages-partials/card-list/proto-list';

@Component({
    selector: 'data-list',
    templateUrl: './card-list.component.html',
    styleUrls: ['./card-list.component.scss'],
    providers: [ColumnSortService],
    standalone: false
})
export class CardListComponent extends ProtoList<any> implements OnInit {
  @Input()
  set listItems(items) {
    this.items = items;
    this.totalItems = items?.length ?? 0;
    if (this.cellProps) { this.setTitles(this.cellProps); }
  }
  @Input() set loading(isLoading: boolean) {
    this.isLoading = isLoading;
  };

  constructor(private sortService: ColumnSortService) {
    super();
  }
  ngOnInit(): void {
    this.sortService.sortColumn$.subscribe(sortEvent => this.items = this.sortItems(this.items, sortEvent));
    }
}
